import React from 'react'
import { fromJSX, Widget } from 'widgets-for-react'
import {
  ComponentDidMount,
  ComponentWillUnmount,
} from '../../utils/lifecycleMethods'
import { getCurrentView, ViewListenerState } from './viewListenerState'

export const viewListenerWidget: Widget<ViewListenerState> = fromJSX(
  (setState) => {
    const onResize = () => setState(getCurrentView())

    return (
      <>
        <ComponentDidMount
          onMount={() => {
            window.addEventListener('resize', onResize)
          }}
        />
        <ComponentWillUnmount
          onUnmount={() => window.removeEventListener('resize', onResize)}
        />
      </>
    )
  }
)
